import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { PointFeatureInterface, PointFeaturesInterface } from '@models/point';
import { SegmentFeatureInterface, SegmentFeaturesInterface } from '@models/segment';
import { RegionFeature, RegionFeatures } from '@models/region';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { GeoFeatureInterface, GeoFeaturesInterface } from '@models/geo-features';

@Injectable({
  providedIn: 'root'
})
export class MapDataService {
  private headers = new HttpHeaders({
    'Content-Type':  'application/json',
    'Accept': 'application/json'
  });

  constructor(private http: HttpClient) {}

  public getFeatures(featureType: string, bounds?: google.maps.LatLngBoundsLiteral): Observable<GeoFeaturesInterface> {
    let res: Observable<GeoFeaturesInterface>;
    let append = bounds ? `/?in_bbox=${bounds.west},${bounds.south},${bounds.east},${bounds.north}` : '';

    switch(featureType) {
      case 'Segment':
        res = this.http.get<SegmentFeaturesInterface>(environment.baseUrl + 'walls/segments' + append);
        break;
      case 'Region':
        res = this.http.get<RegionFeatures>(environment.baseUrl + 'walls/regions' + append);
        break;
      default:
      case 'Point':
        res = this.http.get<PointFeaturesInterface>(environment.baseUrl + 'walls/points' + append);
        break;
    }

    return res;
  }

  public createFeature(feature: GeoFeatureInterface): Observable<GeoFeatureInterface> {
    let res: Observable<GeoFeatureInterface>;
    switch(feature.geometry.type) {
      case 'LineString':
        res = this.http.post<SegmentFeatureInterface>(environment.baseUrl + 'walls/segments/', JSON.stringify(feature), {headers: this.headers, observe: 'body', responseType: 'json'});
        break;
      case 'Polygon':
        res = this.http.post<RegionFeature>(environment.baseUrl + 'walls/regions/', JSON.stringify(feature), {headers: this.headers, observe: 'body', responseType: 'json'});
        break;
      default:
      case 'Point':
        res = this.http.post<PointFeatureInterface>(environment.baseUrl + 'walls/points/', JSON.stringify(feature), {headers: this.headers, observe: 'body', responseType: 'json'});
        break;
    }

    return res;
  }

  public deleteFeature(featureType: string, id: number) {
    let res: Observable<ArrayBuffer>;
    switch(featureType) {
      case 'Segment':
        res = this.http.delete(environment.baseUrl + 'walls/segments/' + id + '/', {headers: this.headers, observe: 'body', responseType: 'arraybuffer'});
        break;
      case 'Region':
        res = this.http.delete(environment.baseUrl + 'walls/regions/' + id + '/', {headers: this.headers, observe: 'body', responseType: 'arraybuffer'});
        break;
      default:
      case 'Point':
        res = this.http.delete(environment.baseUrl + 'walls/points/' + id + '/', {headers: this.headers, observe: 'body', responseType: 'arraybuffer'});
        break;
    }

    return res;
  }
}
